/**
 * BenefitsSection - Why Choose Us section
 * Features: Icon-based cards, hover animations
 */
import { Container, Grid, Box, Paper, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { getBenefits } from "../constants/benefits";

const BenefitsSection = () => {
  const { t } = useTranslation();
  const benefits = getBenefits(t);

  return (
    <Box sx={{ bgcolor: "background.paper", py: 6 }}>
      <Container>
        <Typography
          variant="overline"
          align="center"
          display="block"
          sx={{ color: "primary.main", fontWeight: 700, letterSpacing: "0.15em", mb: 1 }}
        >
          {t("home.benefits.eyebrow")}
        </Typography>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.8rem", md: "2.2rem" },
            mb: 4,
            color: "text.primary",
          }}
        >
          {t("home.benefits.title")}
        </Typography>
        <Grid container spacing={4}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
              >
                <Paper
                  elevation={2}
                  sx={{
                    p: 3,
                    height: "100%",
                    textAlign: "center",
                    transition: "all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow: (theme) =>
                        `0 12px 24px ${theme.palette.primary.main}22`,
                    },
                  }}
                >
                  <Box sx={{ color: "primary.main", mb: 2 }}>
                    {benefit.icon}
                  </Box>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{ fontWeight: 600 }}
                  >
                    {benefit.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {benefit.description}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default BenefitsSection;
